import SortingSettings from '@features/SortingSettings/ui/SortingSettings';

export default function SortingSettingPage() {
  return <SortingSettings />;
}
